<script>
export default {
  functional: true,

  props: {
    heading: { type: String },
    noPaddingX: { type: Boolean },
    boxed: { type: Boolean }
  },

  render(h, { props, slots, data }) {
    let classList = ["v-list", "container", data.staticClass, data.class]

    if (props.noPaddingX) classList.push("--no-padding-x")

    if (props.boxed) {
      return (
        <div class={classList.join(" ")}>
          {props.heading && <span class="v-list__header">{props.heading}</span>}
          <div class="v-list__box">{slots().default}</div>
        </div>
      )
    } else {
      return (
        <div class={classList.join(" ")}>
          {props.heading && <span class="v-list__header">{props.heading}</span>}
          {slots().default}
        </div>
      )
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.v-list {
  &.--no-padding-x {
    .v-list-item .v-list-item__row {
      padding-left: 0;
      padding-right: 0;
    }
  }
}

.v-list__box {
  border-radius: var(--border-radius);
  box-shadow: var(--card-shadow);
  margin-left: $size--4;
  margin-right: $size--4;
  background: $color-ui--white;
  overflow: hidden;
}

.v-list__header {
  display: block;
  font-weight: $font-weight--semi-bold;
  color: $color-ui--grey-70;
  line-height: 25px;
  font-size: $font-size--small;
  padding: $size--2 $size--4;
}

.--dark-mode {
  .v-list__box {
    box-shadow: var(--box-shadow--keyline);
  }
}
</style>
